import {NullableKeys} from '@fl/cmsch-fe-library';

import {ContactType} from 'api/gen/ContactType';
import {ContactValue} from 'api/gen/ContactValue';

/** Form name used for user contact edits. */
export const userContactFormName = 'userContactForm';

/** Values submitted by the user contact form. */
export interface UserContactFormValues {
    /** Free-form contact value. */
    value: ContactValue;
    /** Contact type to store for the user. */
    contactType: ContactType;
    /** Owning user profile id. */
    userProfileId: number;
    /** Existing contact id when editing. */
    userContactId: number;
}

/** Empty form values used before the contact form is initialized. */
export const userContactInitialValues: NullableKeys<UserContactFormValues> = {
    value: '',
    contactType: null,
    userProfileId: null,
    userContactId: null,
};
